import { createSlice } from '@reduxjs/toolkit';
import { clearReducers } from 'redux/logout';

export const initialState = {
  items: {},
  loaded: false,
};

const logisticOperatorSlice = createSlice({
  name: 'logisticOperator',
  initialState,
  reducers: {
    initial: () => {},
    fetch: (state) => {
      state.loaded = false;
    },
    success: (state, action) => {
      state.loaded = true;
      action.payload.forEach((logisticOperator) => {
        state.items[logisticOperator.id] = logisticOperator;
      });
    },
    failure: (state) => {
      state.loaded = true;
    },
  },
  extraReducers: {
    [clearReducers]: () => initialState,
  },
});

export const { name, reducer, actions } = logisticOperatorSlice;
